import React, { Component, } from 'react'

import {bindActionCreators} from 'redux';
import { connect } from 'react-redux';
import Firebase from 'firebase/app';

import _ from 'lodash'
import {CCActions, FirebaseUtils, DataActionTypes as DataAT, Constants} from "./../../cc-imports";

class FBHome extends Component {

    static propTypes = {}

    static defaultProps = {}

    static navigationOptions = {
        gesturesEnabled: false
    }

    constructor(props) {
        super(props);
        this.state={
        }
    }

    componentDidMount() {

        // FirebaseUtils.subscribeToAllUsersNotifications();
        //
        // FirebaseUtils.addOnMessageListener((message)=>{
        //     Firebase.auth().currentUser && Firebase.auth().currentUser.getIdToken(false).then((idToken) => {
        //         var currentUserId = this.props.user.user ? this.props.user.user.id:Constants.anonymousUser;
        //         const {skip, limit, matchKey, matchId, leagueId, userId, lbId,ntfnId, category, type, completed, allUsers} = message;
        //         var skipInt = skip ? parseInt(skip):0;
        //         var limitInt = limit ? parseInt(limit):20;
        //         const {actions} = this.props;
        //
        //         switch (type) {
        //             case 'match':
        //                 matchKey && actions.getMatchByKey(matchKey);
        //                 matchId && actions.getMatch(matchId);
        //                 matchId && completed=='true' && actions.getLeaguesByMatchId({skip : skipInt, limit:limitInt, matchId : matchId}, {userId : currentUserId, idToken:idToken}, DataAT.AUTO_REFRESH);
        //                 matchId && completed=='true' && actions.getEntriesByUserIdAndMatchId({  userId: currentUserId, matchId : matchId }, { accessToken: idToken, userId: currentUserId }, DataAT.AUTO_REFRESH);
        //                 break;
        //             case 'league':
        //                 leagueId && actions.getLeague(leagueId,{accessToken:idToken}, DataAT.AUTO_REFRESH);
        //                 category && actions.getLeagues(category,currentUserId,skipInt,limitInt,idToken,DataAT.AUTO_REFRESH);
        //                 break;
        //             case 'lb':
        //                 var lb = this.props.leaderBoard.lbs.byId[lbId];
        //                 lb && actions.fetchLBStatuses({accessToken:idToken}, {lbId:lb.id,userId:currentUserId, skip:skipInt, limit:limitInt}, DataAT.AUTO_REFRESH);
        //                 break;
        //             case 'ntfn':
        //                 var ntfn = _.find(this.props.notifications.notifications, {'id':ntfnId});
        //                 ntfn && actions.getNtfnById({ntfnId:ntfn.id}, DataAT.AUTO_REFRESH);
        //                 skip && limit && actions.fetchNotifications({ userId:currentUserId, skip : skipInt , limit: limitInt }, DataAT.AUTO_REFRESH)
        //                 break;
        //             case 'trns':
        //                 actions.fetchTransactions({accessToken:idToken}, { userId:currentUserId, skip : skipInt , limit: limitInt }, DataAT.AUTO_REFRESH)
        //                 break;
        //             case 'sponsor':
        //                 actions.getSponsorsByUserId({ userId:currentUserId}, DataAT.AUTO_REFRESH)
        //                 break;
        //             case 'user':
        //                 if(currentUserId==userId) {
        //                     actions.getUser({userId : userId}).then(()=>{
        //                         //TODO: later user same as in splash screen
        //                         if(this.props.user && this.props.user.user){
        //                             if(this.props.user.user.emailVerified==true) {
        //                                 actions.hideEmailNotVerifiedMessage();
        //                             }
        //                             else {
        //                                 actions.showEmailNotVerifiedMessage(()=>{
        //                                     FirebaseUtils.resendVerificationEmail();
        //                                 })
        //                             }
        //                         }
        //                     })
        //                 }
        //                 allUsers =='true' && actions.getUser({userId : currentUserId});
        //                 break;
        //         }
        //
        //     })
        // });
    }

    render() {
        return (
            <div/>
        )
    }
}

export default connect(state => ({
        storedDetails: state.storedDetails,
        fireBaseUser: state.fireBaseUser,
        user : state.user, 
        matches : state.matches,
        leagues : state.leagues,
        ccNavigation:state.ccNavigation,
        leaderBoard:state.leaderBoard,
        notifications: state.notifications
    }),
    (dispatch) => ({
        actions: bindActionCreators({ ...CCActions}, dispatch),
        dispatch: dispatch
    })
)(FBHome);


// WEBPACK FOOTER //
// ./src/app/screens/Home/FBHome.js